import { LinkSize, Text, TextColor, TextSize } from '@vizit/atoms';
import { Heading, HeadingVariant, RouterLink } from '@vizit/molecules';
import { cva, cx } from '@vizit/theme';

const styles = {
  container: cva({ base: 'flex min-h-[50vh] flex-col items-start justify-center gap-4 px-8 py-16' }),
};

export interface NoAccessScreenProps {
  title?: string;
  description?: string;
  fallbackHref?: string | null;
  fallbackLabel?: string;
  className?: string;
}

function NoAccessScreen(props: NoAccessScreenProps) {
  const {
    title = "You don't have access to this page",
    description = 'Contact your administrator if you believe this is a mistake.',
    fallbackHref,
    fallbackLabel = 'Go back',
    className,
  } = props;

  return (
    <div className={cx(styles.container(), className)} data-testid="no-access-screen">
      <Heading variant={HeadingVariant.H2}>{title}</Heading>
      <Text size={TextSize.Md} color={TextColor.Tertiary}>
        {description}
      </Text>
      {fallbackHref ? (
        <RouterLink to={fallbackHref} size={LinkSize.Md} data-testid="no-access-fallback-link">
          {fallbackLabel}
        </RouterLink>
      ) : null}
    </div>
  );
}

export { NoAccessScreen };
